import React from 'react';
import './Pagewrapper.css'

const PageWrapperLayout = ({children}) => {
    return (
        <div className='relative w-full overflow-hidden'>
            <div className='buble-blue-left'></div>
            <div className='buble-blue'></div>
            <div className='buble-red'></div>
            {children}
        </div>
    );
};

export default PageWrapperLayout;